import { BaseLayout } from "./baseLayout"
import Big from "big.js"

export const BaseLeg = {
    mixins: [BaseLayout],

    watch: {
        measures: {
            deep: true,
            handler() {
                if(!this.preview){
                    this.calcDiff()
                    this.debouncedSave()
                }
            }
        },
    },
    methods: {
        calcDiff() {
            console.log("$$ debug: to be extended")
        },
        checkLoad(value, mass, range = null) {
            if (value != undefined && value != null && value != "") {
                let temp = this.checkPrecision(value, this.high_precision)
                if (!temp) {
                    return false
                }
                let currRange = null
                if (range) {
                    currRange = range
                } else {
                    currRange = this.calcMinRange(mass)
                }
                if(currRange){
                    let curr_div = this.has_hi_res ? currRange.d : Big(currRange.e).div(10).toString()
                    temp = this.checkDivisions(value, curr_div)
                    if (!temp) {
                        return false
                    }
                    if(this.instrument_data.uom == "mg" && Big(currRange.e).lte(1)){
                        return Big(value).lte(Big(currRange.e))
                    }
                    let multiplier = 0.9
                    if (this.instrument_data.family == "bilancia nawi meccanica"){
                        multiplier = 1
                    }
                    return Big(value).lte(Big(currRange.e).times(multiplier))
                }
            } 
            return false
        },
        
        addLoadWarning(value, mass, range = null) {
            if (!this.checkLoad(value, mass, range)) {
                return 'error_field'
            }
        },
        calculateAddLoadPlaceholder(mass, range = null) {
            let currRange = range != null ? range : this.calcMinRange(mass)
            if (currRange != null) {
                let multiplier = 0.5
                if (this.instrument_data.family == "bilancia nawi meccanica"){
                    multiplier = 1
                }
                return Big(currRange.e).times(multiplier).toString()
            } else {
                return this.round("0")
            }
        },
        convertPlaceholders(items, maxRange = null) {
            for (let item of items) {
                if(item.mass){
                    item.reading = item.mass
                    let range = maxRange
                    if(range == null){
                        range = this.calcMinRange(item.reading)
                    }
                    if (this.measures.hi_res == "off") {
                        item.addLoad = this.calculateAddLoadPlaceholder(item.mass, range)
                    }
                    item.mpe = this.calc_MPE(range, item.reading)
                    this.changeReading(item, range)
                }
            }
        },
        
    },
    computed: {
        addLoad_overflow() {
            if (this.measures.hi_res == 'off') {
                for (let elm of this.measures.items) {
                    if (!this.checkLoad(elm.addLoad, elm.reading)) {
                        return true
                    }
                }
                return false
            } else {
                return false
            }
        },
        cloneValues(items) {
            for (let item of items) {
                item.reading = JSON.parse(JSON.stringify(item.mass))
            }
        }
    }
}